<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <AutocompleteAcademicLevel
                  v-model="academicLevel"
                  clear-icon="mdi-close"
                  item-text="title"
                  item-value="id"
                  label="Bộ môn"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <AutocompleteDivision
                  v-model="division"
                  item-text="title"
                  item-value="id"
                  label="Chương trình đào tạo"
                  dense
                  outlined
                  auto-select-first
                  :disabled="academicLevelId.length < 1"
                  :hideDetails="true"
                  :filter="{ academicLevel: academicLevelId }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <div class="d-flex justify-end">
                  <v-btn
                    class="search-button"
                    :class="{ 'px-2': windowWidth < 1100 }"
                    @click="onFilterChanged"
                    outlined
                  >
                    Tìm kiếm
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision.vue'
import get from 'lodash-es/get'
import AutocompleteAcademicLevel from '@/components/basic/input/AutocompleteAcademicLevel.vue'

export default {
  components: {
    AutocompleteDivision,
    AutocompleteAcademicLevel,
  },
  data: () => ({
    show: false,
    status: 'active',
    title: '',
    code: '',
    division: null,
    academicLevel: '',
    windowWidth: window.innerWidth,
    get,
  }),
  props: {
    defaultFilters: Object,
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('grade', ['query']),
    academicLevelId() {
      return get(this.academicLevel, 'id', '')
    },
  },
  created() {
    const checkLocalQuery = JSON.parse(localStorage.getItem('grade-query'))
    if (checkLocalQuery) {
      this.title = get(checkLocalQuery, 'title_contains', '')
      this.code = get(checkLocalQuery, 'code_contains', '')
    }
  },
  methods: {
    ...mapActions({
      setQuery: 'grade/setQuery',
      fetchTree: 'docCategory/fetchTree',
    }),
    onFilterChanged() {
      let query = {
        academicLevel: get(this.academicLevel, 'id'),
      }
      if (this.division) query = { ...query, division: this.division }
      this.$emit('onFilterChanged', query)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
